import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IJointCommittee } from "../../utils/types/models";

export default createEntityReducer<IJointCommittee>(Endpoint.JointCommittees, Endpoint.JointCommitteesList);
